import React from "react";
import FaqImage from '../../assets/home/faq-image.png'
import { useTranslation } from "react-i18next";
import { 
    Background, 
    QuestionTittle,
    QuestionWrapper,
    QuestionImage,
    QuestionP,
    AnswerP
} from "./styles";

const Faq = () => {
    const { t } = useTranslation();

    return(
        <Background id="Faq">
            <QuestionTittle>{t("faqs")}</QuestionTittle>
            <QuestionWrapper>
                <QuestionImage src={FaqImage}/>
                <QuestionP>• {t("sizeWineKegs")}</QuestionP>
                <AnswerP>{t("kegsAre20L")}</AnswerP>
                <QuestionP>• {t("typeWineKeg")}</QuestionP>
                <AnswerP>{t("sparklingWinesPolykeg")}</AnswerP>
                <QuestionP>• {t("gasUse")}</QuestionP>
                <AnswerP>{t("CO2gasSparklingWine")}</AnswerP>
                <QuestionP>• {t("gasPressure")}</QuestionP>
                <AnswerP>{t("varyAmbientTemperature")}</AnswerP>
                <QuestionP>• {t("maxLengthRun")}</QuestionP>
                <AnswerP>{t("sparklingWine50m")}</AnswerP>
                <QuestionP>• {t("shelfLifeWineKegs")}</QuestionP>
                <AnswerP>{t("sparklingWines4Weeks")}</AnswerP>
                <QuestionP>• {t("storageWineKegs")}</QuestionP>
                <AnswerP>{t("chilledEnvironments")}</AnswerP>
                <QuestionP>• {t("cleaningLines")}</QuestionP>
                <AnswerP>{t("beerLineCleaner")}</AnswerP>
            </QuestionWrapper>
        </Background>
    )
}
export default Faq;
